module.exports = __webpack_public_path__ + "img/14.19197b2d.jpg";